module.exports = __webpack_public_path__ + "a8acee6831064de4beac503f5c434de7.jpg";